// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientController_UpdateById_Input_IncomeSources_IncomeSources_Items as IncomeSourcesApi,
  MutationInput_LegalClientController_UpdateById_Input_IncomeSources_FinancialSources_Items as FinancialSourcesApi,
  SaveLegalClientIncomeSourcesByAdminDto_Input,
} from 'api/generated/graphql';
import { LegalClientSourcesOfIncomeParam } from 'api/types/params';

export const parseLegalClientSaveSourcesOfIncomeParam = (
  data: LegalClientSourcesOfIncomeParam
): SaveLegalClientIncomeSourcesByAdminDto_Input => ({
  incomeSources: data.incomeSources.map((v) => IncomeSourcesApi[v]),
  otherIncomeSource: data.otherIncomeSource || null,
  financialSources: data.financialSources.map((v) => FinancialSourcesApi[v]),
  otherFinancialSource: data.otherFinancialSource || null,
  confirmationFileIds: data.fileIds,
});
